import React from 'react';
import './style.css';
import { Spinner } from 'reactstrap';
const LoadingOverlay = () => {
  return (
    <>
      <div
        className='loading-overlay'
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
          padding: 0,
          margin: 0,
          top: 0,
          left: 0,
          zIndex: 9999,
        }}
      >
        <Spinner style={{ color: 'white', zIndex: 999, marginBottom: '15px' }} />
        <h4 className='loading-text-pulse' style={{ color: 'white', zIndex: 999, margin: 0 }}>Memuat Data ....</h4>
      </div>
    </>
  );
};

export default LoadingOverlay;
